export enum WorkflowType {
  BulkPrint = 'bulk-print',
  Form = 'form',
  FormAmendment = 'form-amendment',
}
